import services from "../rest/Services";
export default {
    convertStrToLabel: function (str) {
        if (str.includes("_")) {
            str = str.split("_").join(" ").toLowerCase();
        } else {
            str = str.toLowerCase();
        }
        str = str.charAt(0).toUpperCase() + str.slice(1);

        return str;
    },
    checkIfAdmin() {
        const account = JSON.parse(sessionStorage.getItem("account"));
        if (account.roles.includes("ADMIN")) return true;
        return false;
    },
    getPermission(id) {
        const body = {
            functional_unit_id: id,
        };
        return new Promise((resolve) => {
            services.checkEditPermission(body)
                .then((response) => {
                    if (response.status === 200) {
                        resolve(true);
                    }
                })
                .catch((error) => {
                    if (error.response.status === 403) {
                        resolve(false)
                    } else console.log(error)
                });
        });
    }

}
